// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c4e22cbf","513":"ad56bf7c","703":"dcd30daa","787":"56c54fc4"}[chunkId] + ".chunk.js";
};